import { isImage } from "./filesType";
import formatBytes from "./sizeFormat";
import Link from '@mui/material/Link';

export const fileColumns = [
  // {
  //   field: "name",
  //   headerName: "name",
  //   width: 350,
  // },
  {
    field: "preview",
    headerName: "",
    width: 80,
    renderCell: (params) => {
      return (
        isImage(params.row.name) ?
          // <a href={params.row.url} style={{ textDecoration: "none" }} target="_blank">
          <div className="cellWithImg">
            <img className="cellPreview" src={params.row.url} alt="Preview" />
          </div>
          :
          null
      );
    },
  },
  {
    field: "name",
    headerName: "Filename",
    width: 300,
    renderCell: (params) => {
      return (
        <span>{params.row.name.substring(0, params.row.name.lastIndexOf('.')) || params.row.name}</span>
        // isImage(params.row.name) ?
        //   // <a href={params.row.url} style={{ textDecoration: "none" }} target="_blank">
        //   <div className="cellWithImg">
        //     <img className="cellPreview" src={params.row.url} alt="Preview" />
        //     <span>{params.row.name.substring(0, params.row.name.lastIndexOf('.'))}</span>
        //   </div>
        //   :
        //   <span>{params.row.name}</span>
      );
    },
  },
  {
    field: "size",
    headerName: "Size",
    width: 100,
    align: 'right',
    renderCell: (params) => {
      return (
        <span>{formatBytes(params.row.size)}</span>
      );
    },
  },
  {
    field: "updated",
    headerName: "Date",
    width: 250,
    align: 'right',
    renderCell: (params) => {
      const date = new Date(params.row.updated);
      return (
        <span>{date.toLocaleString()}</span>
      );
    },
  },

];

export const contatcColumns = [
  {
    field: "givenName",
    headerName: "Name",
    width: 300,
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    width: 300,
  },
  {
    field: "label",
    headerName: "Type",
    width: 200,
  }

];

export const smsgrouped = [
  {
    field: "title",
    headerName: "Conversation title",
    width: 150,
    renderCell: (params) => (
      <Link
        href={'#'}
      >
        {params.value}
      </Link>
    ),
  },
  {
    field: "latestMessage",
    headerName: "Latest message",
    width: 300,
  },
  {
    field: "screenshot",
    headerName: "Image",
    width: 100,
    renderCell: (params) => {
      return (
        params.row.screenshot ?
          <div className="cellWithImg">
            <a href="" style={{ textDecoration: "none" }} target="_blank" rel="noreferrer" onClick={(e) => {
              e.preventDefault();
              // const win = window.open();
              // win.document.write('<img src="' + params.row.screenshot + '">');
              const win = window.open('img');
              win.document.write('<head><title>View</title></head>');
              win.document.write('<img src="' + params.row.screenshot + '">');

            }}>
              <img className="cellPreview" src={params.row.screenshot} alt="avatar" />
            </a>
          </div> : null
      );
    },
  },
]

export const smsColumns = [
  {
    field: "from",
    headerName: "From",
    width: 150,
  },
  {
    field: "message",
    headerName: "Message",
    width: 500,
    type: 'longText'
    //style={{overflowWrap: 'break-word'}}
  },
  {
    field: "date",
    headerName: "Date",
    width: 250,
    align: 'right',
    // renderCell: (params) => {
    //   const date = new Date(params.row.updated);
    //   return (
    //     <span>{date.toLocaleString()}</span>
    //   );
    // },
  },
  {
    field: "screenshot",
    headerName: "Image",
    width: 100,
    renderCell: (params) => {
      return (
        params.row.screenshot ?
          <div className="cellWithImg">
            <a href="" style={{ textDecoration: "none" }} target="_blank" rel="noreferrer" onClick={(e) => {
              e.preventDefault();
              const win = window.open('img');
              win.document.write('<head><title>View</title></head>');
              win.document.write('<img src="' + params.row.screenshot + '">');
            }}>
              <img className="cellPreview" src={params.row.screenshot} alt="avatar" />
            </a>
          </div> : null
      );
    },
  },

];


export const userColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img} alt="avatar" />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },

  {
    field: "address",
    headerName: "Address",
    width: 100,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];